// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2Mw9V","sendOtp":"AuthorizeToLogin_sendOtp__2aawV"};